import { DocketEntryTypeActions } from './actions'
import { DocketEntryTypeGetters } from './getters'
import { DocketEntryTypeMutations } from './mutations'
import { DocketEntryTypeState } from './state'

export const DOCKET_ENTRY_TYPE_NAMESPACE = 'docketEntryType'

export const DocketEntryType = {
  namespaced: true,
  state: DocketEntryTypeState,
  actions: DocketEntryTypeActions,
  mutations: DocketEntryTypeMutations,
  getters: DocketEntryTypeGetters,
}
